import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export interface WebinarRedirectConfig {
  enabled: boolean;
  url: string;
}

const DEFAULT: WebinarRedirectConfig = { enabled: false, url: '' };
const KEY = 'webinar_redirect';

export function useWebinarRedirect() {
  return useQuery({
    queryKey: ['platform_settings', KEY],
    queryFn: async (): Promise<WebinarRedirectConfig> => {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('value')
        .eq('key', KEY)
        .maybeSingle();
      if (error) throw error;
      return { ...DEFAULT, ...((data?.value as Partial<WebinarRedirectConfig>) ?? {}) };
    },
    staleTime: 30_000,
  });
}

export function useUpdateWebinarRedirect() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (config: WebinarRedirectConfig) => {
      const { error } = await supabase
        .from('platform_settings')
        .upsert({ key: KEY, value: config as any }, { onConflict: 'key' });
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform_settings', KEY] });
      toast.success('Redirección actualizada');
    },
    onError: (e: any) => toast.error(e.message ?? 'Error al actualizar'),
  });
}
